import { formatAmount } from "config/helpers";
import { animate } from "framer-motion";
import { useEffect, useRef } from "react";

const Counter = ({ from, to }) => {
  const nodeRef = useRef();

  useEffect(() => {
    const node = nodeRef.current;

    const controls = animate(from, to, {
      duration: 1,
      onUpdate(value) {
        node.textContent = formatAmount(value.toFixed(0));
      },
    });

    return () => controls.stop();
  }, [from, to]);

  return <span ref={nodeRef} />;
};

export default Counter;
